import {
    FETCH_PUBLICACIONES,
    FETCH_PUBLICACION,
    EDIT_PUBLICACION,
    FETCH_TIPOPUBLICACION,
    IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
    FETCH_ESTADOSVARIACIONES,
    FETCH_MARCAS,
    FETCH_DIMENSIONES,
    FETCH_CATEGORIAS,
    FETCH_MOTIVOS,
    SET_FILTRO_PUBLICACIONES,
    SE_MODIFICARON_IMAGENES,
    LOADING_PUBLICACIONES,
    FETCH_GARANTIAS,
    RESET_PUBLICACIONES,
    SET_IMAGES_UPLOADER,
    HAY_CAMBIOS_EN_IMAGENES,
    UPDATE_PUBLICACIONES_LIST,
    RESET_MARCA_Y_CATEGORIA,
    RESET_LIST_PUBLICACIONES,
    UPDATE_PUBLICACIONES_ESTADO,
    FETCH_ALICUOTA_IVA,
    FETCH_ATRIBUTOS_CATEGORIA,
    FETCH_ATRIBUTOS_POR_PUBLICACION,
    FETCH_ATRIBUTOSCATEGORIA,
    FETCH_VALORESATRIBUTO,
    FETCH_ESTRUCTURAATRIBUTOSVALORES,
    FETCH_AGRUPAMIENTOS,
    FETCH_ATRIBUTOSCATEGORIAAGRUPAMIENTO,
    SET_PRODUCTOVALORES,
    SET_HUBO_CAMBIOS_ESTRUCTURA_ATRIBUTOS
} from '../actions/types';

const initialState = {
    publicaciones: {
        elementos: [],
        cantidades: [],
        cantidadTotal: 0
    },
    loadingPublicaciones: false,
    publicacion: {
        titulo: "",
        ean: "",
        codigoRamatel: "",
        precioLista: "",
        precioPromocional: "",
        descripcionAmpliada: "",
        dimensiones: [{ alto: 0, ancho: 0, profundidad: 0, peso: 0 }],
        categoria: { label: "", value: "" },
        marca: { label: "", value: "" },
        stock: "",
        skuSeller: "",
        imagenes: [],
        alicuotaIva: null,
        alicuotaImpuestoInterno: "",
        idTipoPublicacion: 0,
        tipoPublicacion: {},
        envioGratisZona: {
            amba: true,
            interior: true,
            patagonia: true
        },
    },
    variacionesPublicacion: [],
    tiposPublicacion: [],
    marcas: [],
    categorias: [],
    motivosRevision: [],
    filtroPublicaciones: {},
    dimensiones: [],
    seModificaronImagenes: false,
    loadedSellerTabTipo: false,
    garantias: {},
    imagesUploader: [],
    hayCambiosEnImagenes: false,
    codigoLegibilidad: "",
    descripcionAmpliada: "",
    envioGratis: true,
    envioPropio: false,
    garantiaExtActiva: false,
    garantiaFabrica: 0,
    idMoneda: 0,
    observacion: "",
    precioPromocional: 0,
    linkYoutube: "",
    tiposAlicuotaIva: [],
    //Borrar estos dos
    attributeCategories: { elements: [], total: 0 },
    attributePublicacion: { elements: [] },

    listValores: {},
    listaEstructura: {},
    listaAtributos: {},
    listAgrupamiento: {},
    listAtributosAgrupamiento: {},
    productoValores: {},
    huboCambiosEstructuraAtributosValores: false
}

export default function (state = initialState, action) {

    switch (action.type) {
        case SE_MODIFICARON_IMAGENES:
            return {
                ...state,
                seModificaronImagenes: action.payload
            };
        case SET_FILTRO_PUBLICACIONES:
            return {
                ...state,
                filtroPublicaciones: action.payload
            };
        case FETCH_PUBLICACIONES:
            return {
                ...state,
                publicaciones: action.payload
            };
        case LOADING_PUBLICACIONES:
            return {
                ...state,
                loadingPublicaciones: action.payload
            };
        case FETCH_PUBLICACION:
            return {
                ...state,
                publicacion: action.payload || {},
                dimensiones: action.payload?.dimensiones || []
            }
        case EDIT_PUBLICACION:
            return {
                ...state,
                publicacion: action.payload,
                dimensiones: action.payload.dimensiones
            };
        case FETCH_TIPOPUBLICACION:
            return {
                ...state,
                tiposPublicacion: action.payload
            };
        case IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB:
            return {
                ...state,
                loadedSellerTabTipo: action.payload
            };
        case FETCH_ESTADOSVARIACIONES:
            return {
                ...state,
                variacionesPublicacion: action.payload
            };
        case FETCH_MARCAS:
            return {
                ...state,
                marcas: action.payload
            };
        case FETCH_CATEGORIAS:
            return {
                ...state,
                categorias: action.payload
            };
        case FETCH_MOTIVOS:
            return {
                ...state,
                motivosRevision: action.payload
            };
        case FETCH_DIMENSIONES:
            return {
                ...state,
                dimensiones: action.payload
            };
        case FETCH_GARANTIAS:
            return {
                ...state,
                garantias: action.payload
            };
        case RESET_PUBLICACIONES:
            return {
                ...state,
                publicacion: action.payload,
                //filtroPublicaciones: {}
            };
        case RESET_LIST_PUBLICACIONES:
            return {
                ...state,
                publicaciones: []
            };
        case SET_IMAGES_UPLOADER:
            return {
                ...state,
                imagesUploader: action.payload
            };
        case HAY_CAMBIOS_EN_IMAGENES:
            return {
                ...state,
                hayCambiosEnImagenes: action.payload
            };
        case UPDATE_PUBLICACIONES_LIST:
            return {
                ...state,
                publicaciones: action.payload
            }
        case RESET_MARCA_Y_CATEGORIA:
            return {
                ...state,
                publicacion: {
                    ...state.publicacion,
                    categoria: undefined,
                    marca: undefined,
                },
            };
        case UPDATE_PUBLICACIONES_ESTADO:
            return {
                ...state,
                publicaciones: action.payload,
            };
        case FETCH_ALICUOTA_IVA:
            return {
                ...state,
                tiposAlicuotaIva: action.payload,
            }
        case FETCH_ATRIBUTOS_CATEGORIA:
            return {
                ...state,
                attributeCategories: action.payload
            };
        case FETCH_ATRIBUTOS_POR_PUBLICACION:
            return {
                ...state,
                attributePublicacion: action.payload
            };
        /// ATRIBUTOS
        case FETCH_VALORESATRIBUTO:
            return {
                ...state,
                listValores: action.payload,
            }
        case FETCH_ESTRUCTURAATRIBUTOSVALORES:
            return {
                ...state,
                listaEstructura: action.payload
            };
        case FETCH_ATRIBUTOSCATEGORIA:
            return {
                ...state,
                listAtributos: action.payload
            };
        case FETCH_AGRUPAMIENTOS:
            return {
                ...state,
                listAgrupamiento: action.payloadS
            };
        case FETCH_ATRIBUTOSCATEGORIAAGRUPAMIENTO:
            return {
                ...state,
                listAtributosAgrupamiento: action.payload
            };
        case SET_PRODUCTOVALORES:
            return {
                ...state,
                productoValores: action.payload
            };
        case SET_HUBO_CAMBIOS_ESTRUCTURA_ATRIBUTOS:
            return {
                ...state,
                huboCambiosEstructuraAtributosValores: action.payload
            };
        default: return state
    }
}